import { getRelativeDateLocalization } from '../../../helpers/localization/localizationUtils';
import { formatDate as helperFormatDate } from '../../../helpers/date';

function formatDate(date, format, context = {}) {
  const { translate, localizationData } = context;
  let locale = null;
  if (localizationData) {
    locale = getRelativeDateLocalization(translate, localizationData);
  }
  if (date.start !== undefined) {
    return helperFormatDate(date.start, format, locale);
  } else {
    return helperFormatDate(date, format, locale);
  }
}

export { formatDate };
